import { UpdateConferenceNote } from 'domain/usecases/conferenceNote/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteUpdateConferenceNote implements UpdateConferenceNote {
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateConferenceNote.Model>;

  constructor(url: string, httpClient: HttpClient<UpdateConferenceNote.Model>) {
    this.url = url;
    this.httpClient = httpClient;
  }

  update = async (
    params: UpdateConferenceNote.Params,
  ): Promise<UpdateConferenceNote.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.short}/notes/${params.note}`,
      method: 'patch',
      body: params.body,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
